<template>
  <v-container
    grid-list-xs
    class="d-flex flex-column justify-center align-center login-section"
  >
    <v-card class="card">
      <v-card-title
        primary-title
        class="dark-blue white--text title font-weight-medium login-title px-10"
        >Masuk</v-card-title
      >

      <v-container grid-list-xs class="card-body pt-0">
        <v-form class="form px-5" ref="form" v-on:submit.prevent>
          <v-text-field
            label="Email"
            class="mt-10"
            v-model="username"
            filled
            :rules="emailRules"
            @keyup.enter.native="login"
          >
            <template v-slot:prepend-inner>
              <v-icon class="mx-2">mdi-email-outline</v-icon>
            </template>
          </v-text-field>

          <v-text-field
            label="Password"
            filled
            v-model="password"
            :type="show1 ? 'text' : 'password'"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="show1 = !show1"
            :rules="[(v) => !!v || 'Mohon isi password']"
            @keyup.enter.native="login"
          >
            <template v-slot:prepend-inner>
              <v-icon class="mx-2">mdi-lock-outline</v-icon>
            </template>
          </v-text-field>

          <v-row>
            <v-spacer></v-spacer>
            <router-link
              class="text-decoration-none accentDarkBlue--text font-weight-bold"
              to="/forgot-password"
              >Lupa Password</router-link
            >
          </v-row>

          <center class="mt-6">
            <p v-if="error" class="red--text caption">{{ error }}</p>

            <v-btn color="dark-blue white--text btn-auth" @click="login"
              >Masuk</v-btn
            >
            <p class="pt-5 subtitle-1 font-weight-normal">
              Belum punya akun?
              <router-link
                class="
                  text-decoration-none
                  accentDarkBlue--text
                  font-weight-bold
                "
                to="/daftar"
                >Daftar</router-link
              >
            </p>
          </center>
        </v-form>
      </v-container>
    </v-card>
  </v-container>
</template>


<script>
import axios from "axios";
import { EventBus } from "../event-bus";

export default {
  data: () => ({
    username: "",
    password: "",
    error: "",
    show1: false,
    emailRules: [
      (v) => !!v || "Mohon isi email",
      (v) => /.+@.+\..+/.test(v) || "Email tidak valid",
    ],
  }),
  methods: {
    async login() {
      if (this.$refs.form.validate()) {
        EventBus.$emit("startLoading");

        const resLogin = await axios.post(`${this.$api}/login`, {
          username: this.username,
          email: this.username,
          password: this.password,
          role: "user",
        });

        if (resLogin.data.STATUS == "ERROR") {
          EventBus.$emit("stopLoading");
          this.error = resLogin.data.MESSAGE;

          return;
        }

        localStorage.setItem("id", resLogin.data.PAYLOAD.u_id);
        localStorage.setItem("username", resLogin.data.PAYLOAD.u_username);
        localStorage.setItem("token", resLogin.data.PAYLOAD.u_login_token);

        EventBus.$emit("triggerCheckLoginToken");
        EventBus.$emit("stopLoading");

        let hostDestination =
          window.location.hostname === "localhost"
            ? `localhost:${window.location.port}`
            : window.location.hostname;

        window.location.href = `http://${hostDestination}`;
      }
    },
  },
};
</script>



<style scoped>
.card {
  border-radius: 10px !important;
}
.btn-auth {
  width: 100% !important;
  border-radius: 10px !important;
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
  font-size: 1rem;
  letter-spacing: 0.15rem;
}
.dark-blue {
  background-color: #24305e !important;
}

.login-section {
  min-height: 80vh;
}

.login-title {
  font-family: "Montserrat", sans-serif !important;
}

.card-body {
  padding: 30px;
}

.form {
  width: 450px;
}

.icon-img {
  width: 20px;
}

@media screen and (max-width: 600px) {
  .form {
    width: 400px;
  }
}

@media screen and (max-width: 450px) {
  .card {
    width: 90%;
  }

  .form {
    width: 100%;
    margin: 0 auto;
  }

  .btn-block {
    font-size: 0.65rem !important;
  }

  .login-section {
    height: 100vh;
  }
}

@media screen and (max-width: 400px) {
  .btn-block {
    font-size: 0.55rem !important;
  }
}

@media screen and (max-width: 350px) {
  .btn-block {
    font-size: 0.45rem !important;
  }
}
</style>